/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DepartmentColor } from '../models/DepartmentColor';
import type { DepartmentColors } from '../models/DepartmentColors';
import { request as __request } from '../core/request';

export class DepartmentColorService {

    /**
     * get department   for the calendar event
     * @returns DepartmentColor get department color for the calendar event
     * @throws ApiError
     */
    public static async getDepartmentColor({
companyId,
departmentId,
}: {
/** The companyId **/
companyId: number,
/** The departmentId **/
departmentId: number,
}): Promise<DepartmentColor> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/departments/${departmentId}/color`,
        });
        return result.body;
    }

    /**
     * add department color for the calendar event
     * @returns DepartmentColor department color for the calendar event added
     * @throws ApiError
     */
    public static async addDepartmentColor({
companyId,
departmentId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The departmentId **/
departmentId: number,
requestBody: DepartmentColor,
}): Promise<DepartmentColor> {
        const result = await __request({
            method: 'POST',
            path: `/companies/${companyId}/departments/${departmentId}/color`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * update department color for the calendar event
     * @returns DepartmentColor department color for the calendar event updated
     * @throws ApiError
     */
    public static async updateDepartmentColor({
companyId,
departmentId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The departmentId **/
departmentId: number,
requestBody: DepartmentColor,
}): Promise<DepartmentColor> {
        const result = await __request({
            method: 'PUT',
            path: `/companies/${companyId}/departments/${departmentId}/color`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * delete department color for the calendar event
     * @returns DepartmentColor department color for the calendar event deleted
     * @throws ApiError
     */
    public static async deleteDepartmentColor({
companyId,
departmentId,
requestBody,
}: {
/** The companyId **/
companyId: number,
/** The departmentId **/
departmentId: number,
requestBody: DepartmentColor,
}): Promise<DepartmentColor> {
        const result = await __request({
            method: 'DELETE',
            path: `/companies/${companyId}/departments/${departmentId}/color`,
            body: requestBody,
        });
        return result.body;
    }

    /**
     * get department color for the calendar event
     * @returns DepartmentColors get list of company department color for the calendar event
     * @throws ApiError
     */
    public static async getCompanyDepartmentColor({
companyId,
}: {
/** The companyId **/
companyId: number,
}): Promise<DepartmentColors> {
        const result = await __request({
            method: 'GET',
            path: `/companies/${companyId}/departments-color`,
        });
        return result.body;
    }

}